import { Image, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { HeaderTitle } from "../../component/Header";
import CheckoutSteps from "../../component/CheckoutSteps";
import { useEffect, useState } from "react";
import { checkCity, checkEmail } from "./fetch";
import { formatDate, isValidEmail } from "../../helper";
import toast from "react-hot-toast";
import { Calendar, Eye, EyeOff, Info, UserCheck } from "react-feather";
import Select from "react-select";
import { genderOptions } from "../../optionValue";
import { useAppContext } from "../../hook/AppContext";

const DetailEvent = () => {
  const [customerStatus, setCustomerStatus] = useState("");
  const [emailVal, setEmailVal] = useState("");
  const [customerData, setCustomerData] = useState(null);
  const [visiblePassword, setVisiblePassword] = useState(true);
  const [cityData, setCityData] = useState([]);

  const { setPersonalData, setEventDetail } = useAppContext();

  const [cityVal, setCityVal] = useState([]);
  const [nameVal, setNameVal] = useState("");
  const [phoneVal, setPhoneVal] = useState("");
  const [genderVal, setGenderVal] = useState(null);
  const [dobVal, setDobVal] = useState("");
  const [passwordVal, setPasswordVal] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;
  const today = new Date();
  const maxDate = new Date(
    today.getFullYear() - 10,
    today.getMonth(),
    today.getDate()
  )
    .toISOString()
    .split("T")[0];

  useEffect(() => {
    if (!data) navigate("/");
  }, [data, navigate]);

  const resetState = () => {
    setCustomerStatus("");
    setEmailVal("");
    setCustomerData(null);
    setCityVal([]);
    setNameVal("");
    setPhoneVal("");
    setGenderVal(null);
    setDobVal("");
    setPasswordVal("");
  };

  const handleCheckEmail = async () => {
    try {
      if (!isValidEmail(emailVal)) {
        return toast.error("Email Tidak Valid");
      }

      const res = await checkEmail({ email: emailVal });
      if (res.status) {
        if (res.data !== null) {
          setCustomerStatus("avail");
          setCustomerData(res.data);
        } else {
          setCustomerStatus("not-avail");
        }
      }
    } catch (error) {}
  };

  const handleCheckCity = async (data) => {
    if (data.length >= 3) {
      try {
        const res = await checkCity({ city: data });
        if (res.status) {
          if (res.data !== null) {
            setCityData(res.data);
          } else {
            setCityData([]);
          }
        }
      } catch (error) {}
    }
  };

  const handleValidatePersonalDetail = () => {
    if (!nameVal.trim()) {
      toast.error("Nama wajib diisi");
      return false;
    }

    if (!phoneVal.trim()) {
      toast.error("Nomor HP wajib diisi");
      return false;
    } else if (!/^08\d{7,}$/.test(phoneVal)) {
      toast.error("Nomor HP harus diawali dengan 08 dan minimal 9 digit");
      return false;
    }

    if (!cityVal || cityVal.length === 0) {
      toast.error("Kota wajib dipilih");
      return false;
    }

    if (!genderVal) {
      toast.error("Jenis kelamin wajib dipilih");
      return false;
    }

    if (!dobVal) {
      toast.error("Tanggal lahir wajib diisi");
      return false;
    } else {
      const dob = new Date(dobVal);
      const today = new Date();
      const minDob = new Date(
        today.getFullYear() - 15,
        today.getMonth(),
        today.getDate()
      );
      if (dob > minDob) {
        toast.error("Usia minimal harus 15 tahun");
        return false;
      }
    }

    if (!passwordVal.trim()) {
      toast.error("Password wajib diisi");
      return false;
    } else if (passwordVal.length < 6) {
      toast.error("Password minimal 6 karakter");
      return false;
    }

    setPersonalData({
      name: nameVal,
      phone: phoneVal,
      city: cityVal,
      gender: genderVal,
      dob: dobVal,
      password: passwordVal,
      email: emailVal,
    });
    setEventDetail(data);

    toast.success("Data berhasil disimpan");
    navigate(`/ticket/${data?.information?.slug}`);
  };

  const handlePersonalDetail = () => {
    setPersonalData({
      email: emailVal,
      phone: customerData?.phone,
      name: customerData?.fullname,
      password: "999999",
    });
    setEventDetail(data);
    toast.success("Data berhasil disimpan");

    navigate(`/ticket/${data?.information?.slug}`);
  };

  if (!data) return null;

  return (
    <div className="co-wrap">
      <HeaderTitle title={data?.information?.title} />
      <CheckoutSteps current={1} />

      <div className="co-banner">
        <Image
          src={`${process.env.REACT_APP_API_URL_IMAGE}${data?.thumbnail}`}
          className="co-banner-thumb"
          alt={data?.information?.title}
        />
        <div className="co-banner-info">
          <p className="co-banner-title">{data?.information?.title}</p>
          <p className="co-banner-meta">
            <Calendar size={13} />
            {formatDate(data?.start_date || "")} •{" "}
            {(data?.start_time || "").replace(":", ".")}
          </p>
        </div>
      </div>

      <div className="co-section">
        <h5 className="co-section-title">Data Customer</h5>
        <p className="co-section-sub">
          Masukkan email customer untuk melanjutkan pembelian tiket.
        </p>

        <label className="co-label">
          Email Customer<span className="co-req">*</span>
        </label>
        <div className="co-email-group">
          <Form.Control
            className="co-input"
            placeholder="contoh@email.com"
            type="email"
            value={emailVal}
            readOnly={customerStatus !== ""}
            onChange={(e) => setEmailVal(e.target.value)}
          />
          <button
            type="button"
            className={`co-check-btn ${customerStatus !== "" ? "ghost" : ""}`}
            onClick={() =>
              customerStatus !== "" ? resetState() : handleCheckEmail()
            }
          >
            {customerStatus !== "" ? "Ganti" : "Periksa"}
          </button>
        </div>

        {customerStatus === "avail" && (
          <div>
            <div className="co-account">
              <span className="co-account-badge">
                <UserCheck size={13} /> Akun Terdaftar
              </span>
              <div className="co-account-row">
                <p className="co-account-key">Nama</p>
                <p className="co-account-val">{customerData?.fullname}</p>
              </div>
              <div className="co-account-row">
                <p className="co-account-key">No. Handphone</p>
                <p className="co-account-val">{customerData?.phone}</p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => handlePersonalDetail()}
              className="co-btn"
            >
              Lanjutkan
            </button>
          </div>
        )}

        {customerStatus === "not-avail" && (
          <div>
            <h5 className="co-section-title" style={{ marginBottom: 4 }}>
              Daftar Akun Baru
            </h5>
            <p className="co-section-sub">
              Email belum terdaftar. Lengkapi data untuk membuat akun customer.
            </p>

            <div className="co-field">
              <label className="co-label">Nama Lengkap</label>
              <Form.Control
                className="co-input"
                placeholder="Masukkan nama"
                type="text"
                value={nameVal}
                onChange={(e) => setNameVal(e.target.value)}
              />
            </div>

            <div className="co-field">
              <label className="co-label">No. Handphone</label>
              <Form.Control
                className="co-input"
                placeholder="Contoh: 0812xxxxxxx"
                type="number"
                value={phoneVal}
                onChange={(e) => setPhoneVal(e.target.value)}
              />
            </div>

            <div className="co-field">
              <label className="co-label">Jenis Kelamin</label>
              <Select
                placeholder="Pilih jenis kelamin"
                options={genderOptions}
                value={genderVal}
                onChange={(option) => setGenderVal(option)}
              />
            </div>

            <div className="co-field">
              <label className="co-label">Tanggal Lahir</label>
              <Form.Control
                className="co-input"
                type="date"
                max={maxDate}
                value={dobVal}
                onChange={(e) => setDobVal(e.target.value)}
              />
            </div>

            <div className="co-field">
              <label className="co-label">Kota</label>
              <Select
                options={cityData.map((item) => ({
                  value: item?.id,
                  label: item?.name,
                  data: item,
                }))}
                value={cityVal}
                placeholder="Ketik minimal 3 huruf..."
                onInputChange={(option) => {
                  if (option) {
                    handleCheckCity(option);
                  }
                }}
                onChange={(e) => setCityVal(e)}
              />
            </div>

            <div className="co-field">
              <label className="co-label">
                Password<span className="co-req">*</span>
              </label>
              <div className="co-input-wrap">
                <Form.Control
                  className="co-input"
                  value={passwordVal}
                  onChange={(e) => setPasswordVal(e.target.value)}
                  placeholder="Minimal 6 karakter"
                  type={visiblePassword ? "password" : "text"}
                />
                <span
                  className="co-input-eye"
                  onClick={() => setVisiblePassword(!visiblePassword)}
                >
                  {visiblePassword ? <Eye size={18} /> : <EyeOff size={18} />}
                </span>
              </div>
            </div>

            <p className="co-hint">
              <Info size={15} />
              <span>
                Gunakan <strong>12345678</strong> sebagai password default.
                E-tiket akan dikirim ke email customer setelah pembayaran
                berhasil.
              </span>
            </p>

            <button
              type="button"
              onClick={() => handleValidatePersonalDetail()}
              className="co-btn mt"
            >
              Lanjutkan
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailEvent;
